import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';

export const STUDENT_IMAGE_STATUS_DISPLAY_IMAGE = 0;
export const STUDENT_IMAGE_STATUS_DISPLAY_DROPZONE = 1;
export const STUDENT_IMAGE_STATUS_DISPLAY_PREVIEW = 2;
export const STUDENT_IMAGE_STATUS_DISPLAY_STOCK_PREVIEW = 3;

export const GENERIC_ACCOUNTS = {
  STATUS_2: '200',
  STATUS_3: '300',
  STATUS_4: '400',
  STATUS_5: '500',
  STATUS_6: '600',
  STATUS_7: '700',
  STATUS_8: '800',
  STATUS_9: '900',
};

export const GENERIC_ACCOUNT_IDS = new Set([
  GENERIC_ACCOUNTS.STATUS_2,
  GENERIC_ACCOUNTS.STATUS_3,
  GENERIC_ACCOUNTS.STATUS_4,
  GENERIC_ACCOUNTS.STATUS_5,
  GENERIC_ACCOUNTS.STATUS_6,
  GENERIC_ACCOUNTS.STATUS_7,
  GENERIC_ACCOUNTS.STATUS_8,
  GENERIC_ACCOUNTS.STATUS_9,
]);

export const NON_STUDENT_STATUSES = [
  StatusEnum.Teacher,
  StatusEnum.Adult,
  StatusEnum.SchoolFoodService,
  StatusEnum.Catering,
];

export const STUDENT_NOTES_SERVICE_USERNAME = 'SERVICE';



// WEBPACK FOOTER //
// ./src/common/Constants/student.js